import {Inject, Injectable} from '@angular/core';
import {ApiService, API_SERVICE} from '@velites/ng-api';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(@Inject(API_SERVICE) private apiService: ApiService) {
  }

  Login(model: any): Observable<any> {
    return this.apiService.postJson(`User/LoginByPassword`, {
        body: model
    });
  }

  Logout(): Observable<any> {
    return this.apiService.getJson(`User/LogoutByPassword`);
  }
}
